module.exports = __webpack_public_path__ + "img/public/SiteIcons/incrementMinus-sign.svg?bf09f039";